import { render, staticRenderFns } from "./WorkspaceMarkdownBlock.vue?vue&type=template&id=5a6b8248&scoped=true"
import script from "./WorkspaceMarkdownBlock.vue?vue&type=script&lang=js"
export * from "./WorkspaceMarkdownBlock.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMarkdownBlock.vue?vue&type=style&index=0&id=5a6b8248&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b8248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6b8248')) {
      api.createRecord('5a6b8248', component.options)
    } else {
      api.reload('5a6b8248', component.options)
    }
    module.hot.accept("./WorkspaceMarkdownBlock.vue?vue&type=template&id=5a6b8248&scoped=true", function () {
      api.rerender('5a6b8248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceMarkdownBlock.vue"
export default component.exports